'use client';

import { APP_EVENTS, logHubxEvent } from '@/app/providers/analytics';
import { formatAnalyticsSource } from '@/helpers/common';
import useCustomSearchParams from '@/hooks/useCustomSearchParams';
import { useIsMobile } from '@/hooks/useIsMobile';
import { usePathname } from 'next/navigation';
import React from 'react';

export default function useTrackBtnUpload(toolType?: string) {
  const { getParam } = useCustomSearchParams();
  const pathname = usePathname();
  const isMobile = useIsMobile();

  const formattedToolType = React.useMemo(() => {
    if (toolType) {
      return formatAnalyticsSource(toolType);
    }

    const currentTool = getParam('tool') || pathname.split('/').filter(Boolean).pop();
    return formatAnalyticsSource(currentTool);
  }, [toolType, getParam, pathname]);

  return React.useCallback(() => {
    const viewType = isMobile ? 'mobile' : 'web';

    logHubxEvent({
      eventName: APP_EVENTS.BTN_UPLOAD,
      source: formattedToolType,
      event_params: {
        source: {
          toolType: formattedToolType,
          viewType,
        },
      },
    });
  }, [formattedToolType, isMobile]);
}
